import { useCallback, useLayoutEffect, useRef, useState } from 'react';

/**
 * Tracks whether an <img> has finished loading, attach `ref` to the element
 * and spread `onLoad`/`onError` onto it. Use `loaded` to drive an opacity fade.
 */
export function useImageLoaded(src?: string | null) {
  const ref = useRef<HTMLImageElement>(null);
  const [loaded, setLoaded] = useState(false);

  // Cached images can fire `load` before this effect/handler attaches, so
  // re-check `complete`/`naturalWidth` synchronously whenever src changes
  // instead of relying solely on the onLoad event.
  useLayoutEffect(() => {
    setLoaded(!!(ref.current?.complete && ref.current.naturalWidth > 0));
  }, [src]);

  const markLoaded = useCallback(() => setLoaded(true), []);

  return { ref, loaded, onLoad: markLoaded, onError: markLoaded };
}
